export default __webpack_public_path__ + "static/media/lite_order_ticket.65652b18.png";